var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnglish(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_94_725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.75H14V11.25H0V0.75Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 9.88283L8.82292 6.00001L14 2.11719V0.75H12.1771L7 4.63282L1.82292 0.75H0V2.11719L5.17709 6.00001L0 9.88283V11.25H1.82294L7 7.3672L12.1771 11.25H14V9.88283Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000434449 0.74942L-0.000305176 0.750406V1.29676L6.27078 6.00008L-0.000305176 10.7034V11.2498L0.262446 11.6001L6.99994 6.54696L13.7374 11.6001L14.2624 10.9001L7.72911 6.00008L14.2624 1.10008L13.9995 0.74942H13.2717L6.99994 5.45321L0.728236 0.74942H0.000434449Z",
    fill: "#DC251C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 4.25V0.75H8.75V4.25H14V7.75H8.75V11.25H5.25V7.75H0V4.25H5.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.125 5.125V0.75H7.875V5.125H14V6.875H7.875V11.25H6.125V6.875H0V5.125H6.125Z",
    fill: "#DC251C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_94_725"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 10.5,
    fill: "white",
    transform: "translate(0 0.75)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglish);
export default __webpack_public_path__ + "static/media/english.30687b7f8ed1544082e763313f7cf695.svg";
export { ForwardRef as ReactComponent };